import { formatterRub } from '@/shared/utils'

interface LimitSectionProps {
  dailyLimit: number
  monthlyLimit: number
  variant?: 'card' | 'table' | 'full' | 'big'
  dailyAmountInRub?: number
  monthlyAmountInRub?: number
}

export const LimitSection = ({
  dailyLimit,
  monthlyLimit,
  dailyAmountInRub,
  monthlyAmountInRub,
}: LimitSectionProps) => {
  return (
    <div className="pb-6 border-b border-b-card-border dark:border-b-card-border-dark w-full">
      <div className="flex flex-col gap-4 w-full">
        <div className="flex flex-col">
          <span className="text-sm">Оборот фермы (RUB)</span>
          <div className="flex gap-8">
            <div className="flex flex-col gap-2">
              <span className="text-text-secondary">суточный</span>
              <span>{formatterRub.format(dailyAmountInRub ?? 0)}</span>
            </div>
            <div className="flex flex-col gap-2">
              <span className="text-text-secondary">месячный</span>
              <span>{formatterRub.format(monthlyAmountInRub ?? 0)}</span>
            </div>
          </div>
        </div>

        <div className="flex-1">
          <div className="flex justify-between">
            <span className="text-sm">Лимит на один реквизит (RUB)</span>
          </div>
          <div className="flex gap-8">
            <div className="flex flex-col gap-2">
              <span className="text-text-secondary">суточный</span>
              <span>{formatterRub.format(dailyLimit ?? 0)}</span>
            </div>
            <div className="flex flex-col gap-2">
              <span className="text-text-secondary">месячный</span>
              <span>{formatterRub.format(monthlyLimit ?? 0)}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
